module.exports = __webpack_public_path__ + "img/once_de.14932b4d.png";